import React from 'react';
import { useTenant } from '../Context/TenantContext';

const PLATFORM_NAME        = 'The Skill Genie';
const PLATFORM_URL         = 'https://theskillgenie.com';
const PLATFORM_COMPANY_URL = 'https://evolvexinnovations.com';
const YEAR                 = new Date().getFullYear();

const TenantLoginFooter = () => {
  const {
    getCollegeName,
    getLogoUrl,
    getCollegePhone,
    getCollegeEmail,
    getCollegeWebsite,
    getCollegeLocation,
  } = useTenant();

  const collegeName = getCollegeName();
  const logoUrl     = getLogoUrl();
  const phone       = getCollegePhone();
  const email       = getCollegeEmail();
  const website     = getCollegeWebsite();
  const location    = getCollegeLocation();

  const websiteDisplay = website ? website.replace(/^https?:\/\//, '') : null;
  const websiteHref    = website
    ? (website.startsWith('http') ? website : `https://${website}`)
    : null;

  return (
    <footer
      aria-label={`${collegeName} — site footer`}
      style={{
        backgroundColor: '#5B21B6',
        color: 'rgba(255,255,255,0.82)',
        fontFamily: "'Inter','Segoe UI',system-ui,sans-serif",
        borderTop: '1px solid rgba(255,255,255,0.08)',
      }}
    >
      {/* Accent line */}
      <div style={{ height: '2px', background: 'linear-gradient(90deg,#818CF8,#A78BFA,#C4B5FD)' }} />

      {/* Main row */}
      <div style={{
        display: 'flex', flexWrap: 'wrap', alignItems: 'center',
        justifyContent: 'space-between', gap: 20,
        maxWidth: 1100, margin: '0 auto',
        padding: '20px 28px',
      }}>

        {/* Left: College identity */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
          {logoUrl && (
            <img
              src={logoUrl}
              alt={`${collegeName} logo`}
              style={{
                width: 36, height: 36, borderRadius: 8,
                objectFit: 'contain', background: 'rgba(255,255,255,0.12)',
                padding: 3,
              }}
              onError={e => { e.target.style.display = 'none'; }}
            />
          )}
          <span style={{ fontSize: 14, fontWeight: 800, color: '#fff', letterSpacing: '0.2px' }}>
            {collegeName}
          </span>
        </div>

        {/* Centre: Contact chips */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'center' }}>
          {location && (
            <span style={chipStyle}>
              <span style={{ opacity: 0.7 }}>📍</span> {location}
            </span>
          )}
          {phone && (
            <a href={`tel:${phone}`} style={linkChipStyle} aria-label={`Call ${phone}`}>
              <span style={{ opacity: 0.7 }}>📞</span> {phone}
            </a>
          )}
          {email && (
            <a href={`mailto:${email}`} style={linkChipStyle} aria-label={`Email ${email}`}>
              <span style={{ opacity: 0.7 }}>✉</span> {email}
            </a>
          )}
          {website && (
            <a href={websiteHref} target="_blank" rel="noopener noreferrer" style={linkChipStyle}>
              <span style={{ opacity: 0.7 }}>🌐</span> {websiteDisplay}
            </a>
          )}
        </div>

        {/* Right: Platform branding */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
          <img
            src="/logoo.jpg"
            alt="The Skill Genie"
            style={{ width: 24, height: 24, borderRadius: 6, objectFit: 'contain', background: 'rgba(255,255,255,0.1)', padding: 2 }}
            onError={e => { e.target.style.display = 'none'; }}
          />
          <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', fontWeight: 500 }}>Powered by</span>
          <a
            href={PLATFORM_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontSize: 13, fontWeight: 800, color: '#C4B5FD', textDecoration: 'none', letterSpacing: '0.1px' }}
          >
            {PLATFORM_NAME}
          </a>
        </div>
      </div>

      {/* Bottom bar */}
      <div style={{
        borderTop: '1px solid rgba(255,255,255,0.08)',
        display: 'flex', flexWrap: 'wrap',
        justifyContent: 'space-between', alignItems: 'center',
        gap: 8, padding: '10px 28px',
        maxWidth: 1100, margin: '0 auto',
      }}>
        <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.45)' }}>
          © {YEAR} <strong style={{ color: 'rgba(255,255,255,0.7)', fontWeight: 600 }}>{collegeName}</strong>. All rights reserved.
        </span>
        <a
          href={PLATFORM_COMPANY_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', textDecoration: 'none', fontWeight: 500 }}
        >
          An EvolveX Innovations Platform
        </a>
      </div>
    </footer>
  );
};

const chipStyle = {
  fontSize: 12, color: 'rgba(255,255,255,0.72)',
  display: 'flex', alignItems: 'center', gap: 5,
  fontWeight: 500,
};

const linkChipStyle = {
  ...chipStyle,
  color: 'rgba(255,255,255,0.82)',
  textDecoration: 'none',
  transition: 'color 0.15s',
};

export default TenantLoginFooter;
